/*doc
---
title: viewTypeToggle()
name: viewTypeToggle
category: Javascript - General
---

```html_example
<button type="button" class="btn btn-primary has-icon js-view-toggle-btn">
  <i class="db-icon"></i>
</button>
<main id="main-content">
  // TODO Example of content
</main>
```

```js_example
$(document).on('turbolinks:load', function() {
  $('#main-content')
    .viewTypeToggle({
    storageSelector: 'products-display-type',
      toggleButtonSelector: '.js-view-toggle-btn',
      options: [
        { id: 'grid', title: 'Grid View', iconClass: 'db-grid-view-icon', containerClass: 'grid-view' },
        { id: 'list', title: '', iconClass: 'db-list-view-icon', containerClass: 'list-vew' }
      ],
      default: 'grid'
    })
})
```
*/
(function($) {
  'use strict'

  $.fn.viewTypeToggle = viewTypeToggle

  function viewTypeToggle(settings) {
    var $button = $(settings.buttonSelector),
    $container = $(this),
    initialOption = false,
    sessionSelector = ('storageSelector' in settings) ? settings.storageSelector : 'product-display-type',
    current = getOptionById(sessionStorage.getItem(sessionSelector)),
    next = getNextOptionById(current.id),
    previous

    update()

    // Setup Listeners
    $button.on('click', switchToNextView)

    return this

    /**
    * Updates the DOM/route params to match current view type.
    */
    function update() {
      styleButton()
      styleContainer()
      sessionStorage.setItem(sessionSelector, current.id)
    }

    /**
    * Switches the viewtype to the next option in the list
    */
    function switchToNextView() {
      previous = current
      current = next
      next = getNextOptionById(current.id)

      update()
    }

    /**
    * Finds display option by id. Returns undefined if not present.
    */
    function getOptionById(id) {
      var requested = settings.options
        .filter(function(option) {
          return option.id === id
        })[0]

      if (!requested && id !== settings.default) {
        return getOptionById(settings.default)
      }

      return requested
    }

    /**
    * Finds next display option following the one with the given id. If the
    * given option is the last in the list, then the first is returned.
    */
    function getNextOptionById(id) {
      for (var i = 0; i < settings.options.length; i++) {
        if (settings.options[i].id === id) {
          return settings.options[(i+1) % settings.options.length ]
        }
      }
    }

    /**
    * Returns the default option.
    */
    function getDefault() {
      return getOptionById(settings.default)
    }

    /**
    * Styles the toggle button based on current option. Removes style if there
    * was a previously selected option.
    */
    function styleButton() {
      var $buttonIcon = $button.find('i')
      $button.attr('title', current.title ? current.title : '')
      if (current.iconClass && $buttonIcon) {
        $buttonIcon.removeClass(previous ? previous.iconClass : getDefault().iconClass)
        $buttonIcon.addClass(current.iconClass)
      }
    }

    /**
    * Styles the content container based on current option. Removes style if
    * there was a previously selected option.
    */
    function styleContainer() {
      $container.removeClass(previous ? previous.containerClass : getDefault().containerClass)
      $container.addClass(current.containerClass)
    }
  }

}(jQuery))
